export const PaymentType = {
  other: 0,
  bancontact: 1,
  creditcard: 2,
  cash: 3,
};
